export default {
  getDriver: (state) => state.driver,
};
